import { ChangeDetectorRef, Component, DestroyRef, Input, OnChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { HorsePerformanceData } from '@cds/betting-offer/domain-specific/horse-racing/timeform';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { WinGameParticipant } from '@frontend/sports/racing/feature/models';

import { HorseRacingApiService } from '../../../horse-racing-shared/services/horse-racing-api.service';

@Component({
    selector: 'ms-horse-info',
    templateUrl: 'horse-info.component.html',
    standalone: false,
})
export class HorseInfoComponent implements OnChanges {
    @Input() fixtureId: string;
    @Input() participant: WinGameParticipant;

    participantPerformances: HorsePerformanceData[] = [];
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        public sitecore: Sitecore,
        private horseRacesApiService: HorseRacingApiService,
        private changeDetector: ChangeDetectorRef,
    ) {}

    ngOnChanges(changes: ISimpleChanges<HorseInfoComponent>): void {
        if (changes.fixtureId || changes.participant) {
            this.horseRacesApiService
                .getHorsePerformance(this.fixtureId, this.participant.id)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((val) => {
                    this.participantPerformances = val || [];
                    this.changeDetector.markForCheck();
                });
        }
    }
}
